export default {
  appURL: 'https://app.zaizhexue.top',
  baseURL: 'https://api.zaizhexue.top',
  // baseURL: 'http://127.0.0.1:3000',
  loginURL: '/api/login',
  registerURL: '/api/register',
  collectionsURL: '/api/collections',
  randomImageURL: '/api/random-image',
  paperURL: '/api/paper',
  triggerURL: '/api/trigger',
  pollingURL: '/api/polling',
  favoriteURL: '/api/favorites',
  userInfoURL: '/api/user/info',
  resetTokenURL: '/api/user/reset-token',
  getAllSets: '/api/question-sets',
  createSet: '/api/question-sets',
  deleteSet: '/api/question-sets',
  getSetQuestions: '/api/question-sets' // Used for getting questions from a set
};